"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectMulti = void 0;

var React = _interopRequireWildcard(require("react"));

var _Select = require("grommet/components/Select");

var _Icons = require("./Icons");

var _DefaultRenderValue = require("./DefaultRenderValue");

var _DefaultRenderOption = _interopRequireDefault(require("./DefaultRenderOption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SelectMulti = function SelectMulti(_ref) {
  var options = _ref.options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      onChange = _ref.onChange,
      _ref$renderValue = _ref.renderValue,
      renderValue = _ref$renderValue === void 0 ? _DefaultRenderValue.DefaultRenderValue : _ref$renderValue,
      _ref$renderOption = _ref.renderOption,
      renderOption = _ref$renderOption === void 0 ? _DefaultRenderOption.default : _ref$renderOption,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Select one or more' : _ref$placeholder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose;

  var handleChange = function handleChange(e) {
    return onChange(e.value);
  };
  /* Store open state to render correct icon */


  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleOpen = function handleOpen() {
    setOpen(true);
    if (onOpen) onOpen();
  };

  var handleClose = function handleClose() {
    setOpen(false);
    if (onClose) onClose();
  };

  return React.createElement(_Select.Select, {
    multiple: true,
    closeOnChange: false,
    placeholder: placeholder,
    disabled: disabled,
    options: options,
    value: value,
    onChange: handleChange,
    valueLabel: renderValue(value, handleChange, disabled),
    labelKey: "label",
    valueKey: "value",
    onOpen: handleOpen,
    onClose: handleClose,
    icon: open ? React.createElement(_Icons.ArrowUpIcon, null) : React.createElement(_Icons.ArrowDownIcon, null)
  }, renderOption);
};

exports.SelectMulti = SelectMulti;